import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const unitSchema: CollectionCreateSchema = {
  name: CollectionName.Unit,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "list_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "unit_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "unit_name",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "symbol",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "active",
      type: "bool",
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
